"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonQuotedColumnParser = void 0;

var ColumnFormatter_1 = require("./ColumnFormatter");

var Token_1 = require("../Token");

var NonQuotedColumnParser = /*#__PURE__*/function () {
  function NonQuotedColumnParser(parserOptions) {
    _classCallCheck(this, NonQuotedColumnParser);

    this.parserOptions = parserOptions;
    this.columnFormatter = new ColumnFormatter_1.ColumnFormatter(parserOptions);
  }

  _createClass(NonQuotedColumnParser, [{
    key: "parse",
    value: function parse(scanner) {
      if (!scanner.hasMoreCharacters) {
        return null;
      }

      var parserOptions = this.parserOptions;
      var characters = [];
      var nextToken = scanner.nextCharacterToken;

      for (; nextToken; nextToken = scanner.nextCharacterToken) {
        if (Token_1.Token.isTokenDelimiter(nextToken, parserOptions) || Token_1.Token.isTokenRowDelimiter(nextToken)) {
          break;
        }

        characters.push(nextToken.token);
        scanner.advancePastToken(nextToken);
      }

      return this.columnFormatter.format(characters.join(''));
    }
  }]);

  return NonQuotedColumnParser;
}();

exports.NonQuotedColumnParser = NonQuotedColumnParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL05vblF1b3RlZENvbHVtblBhcnNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQ0EsSUFBQSxpQkFBQSxHQUFBLE9BQUEsQ0FBQSxtQkFBQSxDQUFBOztBQUVBLElBQUEsT0FBQSxHQUFBLE9BQUEsQ0FBQSxVQUFBLENBQUE7O0lBRWEscUI7QUFLVCxpQ0FBbUIsYUFBbkIsRUFBK0M7QUFBQTs7QUFDM0MsU0FBSyxhQUFMLEdBQXFCLGFBQXJCO0FBQ0EsU0FBSyxlQUFMLEdBQXVCLElBQUksaUJBQUEsQ0FBQSxlQUFKLENBQW9CLGFBQXBCLENBQXZCO0FBQ0g7Ozs7V0FFTSxlQUFNLE9BQU4sRUFBc0I7QUFDekIsVUFBSSxDQUFDLE9BQU8sQ0FBQyxpQkFBYixFQUFnQztBQUM1QixlQUFPLElBQVA7QUFDSDs7QUFId0IsVUFJakIsYUFKaUIsR0FJQyxJQUpELENBSWpCLGFBSmlCO0FBS3pCLFVBQU0sVUFBVSxHQUFHLEVBQW5CO0FBQ0EsVUFBSSxTQUFTLEdBQUcsT0FBTyxDQUFDLGtCQUF4Qjs7QUFDQSxhQUFPLFNBQVAsRUFBa0IsU0FBUyxHQUFHLE9BQU8sQ0FBQyxrQkFBdEMsRUFBMEQ7QUFDdEQsWUFBSSxPQUFBLENBQUEsS0FBQSxDQUFNLGdCQUFOLENBQXVCLFNBQXZCLEVBQWtDLGFBQWxDLEtBQW9ELE9BQUEsQ0FBQSxLQUFBLENBQU0sbUJBQU4sQ0FBMEIsU0FBMUIsQ0FBeEQsRUFBOEY7QUFDMUY7QUFDSDs7QUFDRCxRQUFBLFVBQVUsQ0FBQyxJQUFYLENBQWdCLFNBQVMsQ0FBQyxLQUExQjtBQUNBLFFBQUEsT0FBTyxDQUFDLGdCQUFSLENBQXlCLFNBQXpCO0FBQ0g7O0FBQ0QsYUFBTyxLQUFLLGVBQUwsQ0FBcUIsTUFBckIsQ0FBNEIsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsRUFBaEIsQ0FBNUIsQ0FBUDtBQUNIOzs7Ozs7QUF6QkwsT0FBQSxDQUFBLHFCQUFBLEdBQUEscUJBQUEiLCJzb3VyY2VSb290IjoiIn0=